import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-account\">\n<path class=\"st0\" d=\"M4.2,9.1c0.4,0.4,0.9,0.7,1.4,1c0.5,0.2,1.1,0.3,1.7,0.3s1.2-0.1,1.7-0.3s1-0.6,1.5-1c0.4-0.4,0.7-0.9,1-1.5\n\tc0.2-0.5,0.3-1.1,0.3-1.7s-0.1-1.2-0.3-1.7s-0.6-1-1-1.5c-0.4-0.4-0.9-0.7-1.4-1C8,1.4,6.7,1.4,5.7,1.8c-0.5,0.2-1,0.6-1.5,1\n\tc-0.4,0.4-0.7,0.9-1,1.5C3,4.8,2.9,5.4,2.9,5.9c0,0.6,0.1,1.2,0.3,1.7C3.5,8.2,3.8,8.7,4.2,9.1z\" />\n<path class=\"st0\" d=\"M10.9,11.4H3.8c-2.1,0-3.8,1.7-3.8,3.8S1.7,19,3.8,19H11c2.1,0,3.8-1.7,3.8-3.8C14.7,13.1,13,11.4,10.9,11.4z\" />\n<rect x=\"14\" y=\"1.5\" class=\"st0\" width=\"6\" height=\"2\" />\n<rect x=\"15\" y=\"5.5\" class=\"st0\" width=\"5\" height=\"2\" />\n<rect x=\"16\" y=\"9.5\" class=\"st0\" width=\"4\" height=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/account.svg
// module id = lNpt
// module chunks = 45